/**
 * AI:
 * Status: "confirmed"
 * Type: Component
 * SubType: WidgetConfig
 * Reason: Such-Aktivitätskomponente einer Workflow-Schrittausführung. Zeigt Treffer einer Suche als Tabellen-Widget zur Auswahl an Sachbearbeiter und meldet die Auswahl an die Workflow-Runtime zurück.
 */
import {Component, Input, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {
    WfProcessStepActivityBaseComponent
} from "../wf-process-step-activity-base/wf-process-step-activity-base.component";
import {SearchResultDto} from "../../../../../../feature-power/si/logic/search-result.dto";
import {SearchResultEntryDto} from "../../../../../../feature-power/si/logic/search-result-entry.dto";
import {WfActivityProcessingResultFieldDto} from "../../../../model/dto/api/wf-activity-processing-result-field.dto";
import {WfProcessRuntimeService} from "../../../../service/wf-process-runtime.service";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../../core/shared/dto/object/request/object-request-list";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";

/**
 * TODO: Describe which activities are processed here ...
 */
@Component({
    selector: 'mvs-wf-process-step-activity-search',
    templateUrl: './wf-process-step-activity-search.component.html',
    standalone: false
})
export class WfProcessStepActivitySearchComponent
    extends WfProcessStepActivityBaseComponent
    implements OnInit, OnChanges, OnDestroy {


    // TODO: will adjust WfProcessTypeStepActivityService to get the component based on activity type

    objectType: string;
    selectedObjectId: number;
    searchedResultEntries: SearchResultEntryDto[];
    @Input() searchString: string;
    objectTypeSelectionWidget: WidgetData;

    ngOnInit() {
        super.ngOnInit();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        // TODO: will get object type in activity type

        // TODO: will adjust later as per API result


        this.objectType = this.activityType.activityObjectDto['objectTypeAlias']

        this.initialized = true;
    }

    /**
     * following method gets the searched results
     * @param searchResult
     */
    onSearchResult(searchResult: SearchResultDto) {
        this.searchedResultEntries = searchResult?.searchResultEntries;

        this.handleSelectionWidget();

    }

    /**
     * method gets objectId and update the process component
     * @param objectId
     */
    onSelect(objectId: number) {

        this.selectedObjectId = objectId;

        const result: WfActivityProcessingResultFieldDto = {
            //TODO: ask alias and action from marko
            alias: 'search',
            action: null,
            valueObjectTypeAlias: this.objectType,
            valueObjectId: objectId
        };

        WfProcessRuntimeService.setResult([result])
    }

    handleSelectionWidget() {

        const filterCriteria = FilterCriteria.createOrFromArray('e.id','objectId',this.searchedResultEntries);

        const objectRequestList = new ObjectRequestList(true, [filterCriteria],[]);

        // this.objectTypeSelectionWidget = WidgetFactory.createWidgetTableEntity(
        //     `wf.process.step.activity.search.${this.objectType}`,'Search List',this.objectType,'No Result',objectRequestList
        // )

        /**
         * AI: Tabellen-Widget mit den Treffern der Such-Aktivität eines Workflow-Schritts.
         *     Quelle: dynamischer Objekttyp aus dem Suchergebnis, gefiltert per ID-Liste.
         *     Sachbearbeiter wählen hier den passenden Datensatz aus den Suchergebnissen aus.
         */
        this.objectTypeSelectionWidget = WidgetFactory.createWidgetTableEntityBasicQl(`wf.process.step.activity.search.${this.objectType}`, 'Search List', this.objectType, [filterCriteria])

    }

    onObjectSelect() {

    }



}
